import { Action } from '@ngrx/store';
import { Follow, Country } from '@app/models';

export enum FollowActionTypes {
  Select = '[FollowArea] Select'
}

export class Select implements Action {
  readonly type = FollowActionTypes.Select;
  constructor(public id: number) {}
}

export type FollowAreaActionsUnion = Select;
